// removed by extract-text-webpack-plugin
module.exports = {"unitLabel":"Measurement-style__unitLabel__256tr","divider":"Measurement-style__divider__3wY6t"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Measurement/Measurement-style.scss
// module id = 1716
// module chunks = 4 14